import React from 'react'
import { useDispatch } from 'react-redux'
import { addTopic } from '@app-core/posts/actions'
import { useTranslation } from '@i18n'
import AddTopic from './AddTopic'

export default function AppTopicContainer({ onTopicAdded = () => {} }) {
  const dispatch = useDispatch()
  const submitTopic = async (inputs) => {
    const formData = new FormData()
    formData.append('title', inputs.title)
    formData.append('desc', inputs.description)
    formData.append('privacy', Number(inputs.private))

    const topicId = await dispatch(addTopic({ formData, postId: getPostIdFromPath() }))
    if (topicId) onTopicAdded({ topicId })
  }

  const { t } = useTranslation(['addTopic'])
  return <AddTopic onSubmit={submitTopic} t={t} />
}

function getPostIdFromPath() {
  if (typeof window === 'undefined') return null
  return window.location.pathname
    .split('/')
    .filter((path) => path && path !== 'dev')
    .join('.')
}
